import { render } from "./NewsList.vue?vue&type=template&id=50111e03&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=50111e03&lang=scss&scoped=true"
import "./NewsList.vue?vue&type=style&index=1&id=50111e03&lang=scss"

import exportComponent from "/Users/molinam/gitlab/techbio2025-vue-app/vue-mobile-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50111e03"]])

export default __exports__